/* @flow */

import type {
  MessageFunc,
  ManageGlobal,
  ManageCanvas,
  ManageClock,
  ManageInput,
  ManageSong,
  GlobalConfig,
} from './Common';
import CanvasManager from './CanvasManager';
import ClockManager from './ClockManager';
import InputManager from './InputManager';
import SongManager from './SongManager';

function getDateString() {
  return new Date().getTime();
}

class _GlobalManager implements ManageGlobal {
  canvas: ManageCanvas;
  clock: ManageClock;
  input: ManageInput;
  song: ManageSong;
  config: GlobalConfig;
  setMessageCenter: (Array<string>) => void;
  setMessageTop: (Array<string>) => void;
  isReady: Promise<void>;

  constructor() {
    const { port } = window.location;
    let environment = '';
    if (port === '') {
      environment = 'prod';
    } else if (port.startsWith('8')) {
      environment = 'demo';
    } else if (port.startsWith('3')) {
      environment = 'dev';
    } else {
      throw new Error('failed to load config, unexpected port: ' + port);
    }

    let assetsUrl = null;
    if (environment === 'demo') {
      assetsUrl = 'assets/';
    }
    if (environment === 'dev') {
      assetsUrl = 'http://localhost:8085/';
    }
    if (environment === 'prod' || window.location.search.includes('useS3')) {
      assetsUrl = 'https://s3.amazonaws.com/musicboy/';
    }

    const self = this;
    this.isReady = new Promise((resolve, reject) => {
      fetch(`config.json?v=${getDateString()}`)
        .then(res => res.json())
        .then(config => {
          self.config = {
            ...config,
            environment,
            assetsUrl,
          };
          resolve();
        })
        .catch(reject);
    });
  }
  init(canvasElm: HTMLCanvasElement, setMessageCenter: MessageFunc, setMessageTop: MessageFunc) {
    this.canvas = new CanvasManager(canvasElm);
    this.clock = new ClockManager();
    this.input = new InputManager(this.clock);
    this.song = new SongManager(this.input);
    this.setMessageCenter = setMessageCenter;
    this.setMessageTop = setMessageTop;
  }
  cleanupLevel() {
    const { canvas, clock, input } = this;
    [canvas, clock, input].forEach(m => m.cleanup());
    this.setMessageCenter([]);
    this.setMessageTop([]);
  }
  cleanupAudio() {
    this.song.cleanup();
  }
}

const GlobalManager = new _GlobalManager();

export default GlobalManager;



// WEBPACK FOOTER //
// ./src/GlobalManager.js